export enum BillingInterval {
  MONTH = "month",
  YEAR = "year",
}

export type StripeRecurring = {
  aggregate_usage: null
  interval: BillingInterval
  interval_count: number
  meter: null
  trial_period_days: number | null
  usage_type: string
}

export type StripeCurrencyOptions = {
  [key: string]: {
    custom_unit_amount: null
    tax_behavior: "unspecified"
    unit_amount: number
    unit_amount_decimal: string
  }
}

export type StripePrice = {
  id: string
  currency: string
  unit_amount: number
  recurring: StripeRecurring | null
  currency_options: StripeCurrencyOptions
  activePrice: boolean
}

export type MarketingFeature = {
  name: string
}

export type StripeMetadata = {
  most_popular?: string
  a2v_factor: string
  credits: string
  overage_product_id: string
  public: string
  allow_custom_branding: string
}

export type StripeProduct = {
  id: string
  name: string
  description: string
  metadata: StripeMetadata
  prices: StripePrice[] | null
  marketing_features: MarketingFeature[]
  activePlan: boolean
}

export type StripeProducts = Record<string, StripeProduct>

export type PlanUpdateStatus = "upgraded" | "downgraded" | "changed" | null
